/* TR Mobile Bottom Nav V1 — scroll-direction show/hide, live cart count, overlay awareness */
(function () {
  'use strict';
  var nav = document.getElementById('tr-bottom-nav');
  if (!nav) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var countEl = document.getElementById('tr-bottom-nav-count');
  document.body.classList.add('tr-has-bottom-nav');

  /* ---------- show / hide on content scroll direction ---------- */
  var THRESHOLD = 10;      // px of travel before we react (no jitter)
  var TOP_ZONE = 80;       // always visible near the top
  var BOTTOM_ZONE = 80;    // always visible when the footer is reached
  var lastY = window.pageYOffset;
  var ticking = false;

  function overlayOpen() {
    return !!document.querySelector(
      '.tr-quick-modal.is-open, #tr-filter-drawer.is-open, cart-drawer.active, ' +
      'details-modal details[open], .quick-add-modal[open], .modal-overlay.active'
    ) || document.body.classList.contains('overflow-hidden') ||
      document.documentElement.classList.contains('overflow-hidden');
  }

  function setHidden(h) { nav.classList.toggle('is-hidden', h); }

  function update() {
    ticking = false;
    if (!mq.matches) return;
    if (overlayOpen()) { wasOpen = true; setHidden(true); return; }
    wasOpen = false;

    var y = window.pageYOffset;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var dy = y - lastY;

    if (y <= TOP_ZONE || y >= max - BOTTOM_ZONE) {
      setHidden(false); lastY = y; return;
    }
    if (Math.abs(dy) < THRESHOLD) return;   // small movement: keep state
    setHidden(dy > 0);                      // content moving up (scroll down) => hide
    lastY = y;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });

  /* react to drawers / modals opening and closing */
  var wasOpen = false;   // only react when the overlay state really changes (other scripts rewrite body.class too)
  var mo = new MutationObserver(function () { requestAnimationFrame(function () {
    var o = overlayOpen();
    if (o === wasOpen) return;
    wasOpen = o;
    if (o) setHidden(true); else { setHidden(false); lastY = window.pageYOffset; }
  }); });
  mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  ['.tr-quick-modal', '#tr-filter-drawer', 'cart-drawer'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) mo.observe(el, { attributes: true, attributeFilter: ['class'] });
  });

  /* ---------- real cart count ---------- */
  function setCount(n) {
    if (!countEl) return;
    countEl.textContent = n > 99 ? '99+' : String(n);
    countEl.hidden = !(n > 0);
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count || 0); })
      .catch(function () {});
  }
  refreshCount();
  window.addEventListener('pageshow', refreshCount);
  var drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(refreshCount).observe(drawer, { childList: true });

  /* ---------- Cart / Search reuse the theme's own UI ---------- */
  nav.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nav]');
    if (!a) return;
    var which = a.getAttribute('data-nav');
    if (which === 'cart') {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { e.preventDefault(); d.open(a); }
    } else if (which === 'search') {
      var s = document.querySelector('details-modal.header__search summary, summary.header__icon--search');
      if (s) { e.preventDefault(); s.click(); }
    }
  });
})();
